var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Events from "js/lib/events";
import { MessageChoice } from "js/lib/choice";
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View(controller) {
        var _this = _super.call(this) || this;
        console.log("view", _this);
        _this.controller = controller;
        _this.message = document.querySelector("#message");
        _this.messageContent = document.querySelector("#message > span");
        _this.listenTo(controller, "change:color", _this.setColor.bind(_this));
        _this.listenTo(controller, "change:background", _this.setBackground.bind(_this));
        _this.listenTo(controller, "change:choice", _this.handleChoice.bind(_this));
        return _this;
    }
    // Load player lazily
    View.prototype.getPlayer = function () {
        var _this = this;
        return import(/* webpackChunkName: "player" */ "./player")
            .then(function (_a) {
            var Player = _a.default;
            if (!_this.player)
                _this.player = new Player(_this);
            return _this.player;
        }).catch(function (err) { return console.error(err); });
    };
    View.prototype.showMessage = function (text) {
        this.messageContent.textContent = text;
        this.message.classList.remove("hidden");
    };
    View.prototype.hideMessage = function () {
        this.message.classList.add("hidden");
    };
    View.prototype.setColor = function () {
        this.message.style.color = this.controller.get("color");
    };
    View.prototype.setBackground = function () {
        this.message.style.background = this.controller.get("background");
    };
    View.prototype.handleChoice = function () {
        var _this = this;
        var choice = this.controller.get("choice");
        if (choice instanceof MessageChoice) {
            this.showMessage(choice.text);
            if (this.player)
                this.player.stop();
        }
        else {
            this.hideMessage();
            this.getPlayer().then(function (player) {
                console.log("successfully loaded player");
                player.play(choice, {
                    startTime: parseFloat(_this.controller.get("startTime")),
                    volume: parseFloat(_this.controller.get("volume"))
                });
            });
        }
    };
    return View;
}(Events));
export default View;
